<template>
  <div class="text-page">
    <page-head-static-component :bgImg="require('@/assets/img/news_bg.png')" :ttl="'О компании'"></page-head-static-component>

    <text-container-component></text-container-component>

    <block-container-component
      bgC="#F3F3F3"
      :bgImg="require('@/assets/img/advantages_bg.png')"
      :hide="advhide"
    >
      <template slot="title">
        <block-title-component>
          <template slot="ttl">Преимущества</template>
          <template slot="subttl"></template>
        </block-title-component>
      </template>
      <template slot="content">
        <advantages-component @hideup="advhide=true" type-of-content="advantages"></advantages-component>
      </template>
    </block-container-component>

    <block-container-component
      bgC="#F3F3F3"
      :bgImg="require('@/assets/img/licenz_bg.png')"
      pr0
      :hide="feedbackhide"
    >
      <template slot="title">
        <block-title-component ttlcolor="#FFFFFF">
          <template slot="ttl">Лицензии и аккредитации</template>
        </block-title-component>
      </template>
      <template slot="content">
        <feedback-component type-of-content="feedback" @hideup="feedbackhide=true"></feedback-component>
      </template>
    </block-container-component>

    <block-container-component :hide="partnhide">
      <template slot="title">
        <block-title-component ttlcentr>
          <template slot="ttl">Нам доверяют</template>
          <template slot="subttl"></template>
        </block-title-component>
      </template>
      <template slot="content">
        <partners-component @hideup="partnhide=true"></partners-component>
      </template>
    </block-container-component>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      galhide: false,
      advhide: false,
      dochide: false,
      partnhide: false,
      faqhide: false,
      feedbackhide: false
    };
  }
};
</script>

<style lang="scss" scoped>
.text-page {
  background-color: $bg2Color;
}
</style>
